import Repository from '@/libs/axios'
import OperationRepository from '@/libs/customAxios/operationAxios'

const resource = '/merchant/resource'
const roleResource = '/merchant/roles'
const permissionResource = '/merchant/permissions'
const DropdownResource = '/merchant/resource'
const moduleResource = '/merchant/module'

export default {
  getStateList() {
    return OperationRepository.get(`${resource}/state-list`)
  },
  getStateDropdownList(id) {
    return OperationRepository.get(`${resource}/state-list?filter[country_id]=${id}&noPagination`)
  },
  getCountryList() {
    return OperationRepository.get(`${resource}/country-list`)
  },
  getCityList(stateId = '') {
    return OperationRepository.get(`${resource}/city-list?${stateId ? `state_id=${stateId}` : ''}&noPagination`)
  },
  getAutoCityDropdownList(filter) {
    return OperationRepository.get(`${resource}/city-list?filter[name]=${filter}&noPagination&verify=true`)
  },
  getCityListDropdownList() {
    return OperationRepository.get(`${resource}/city-list?noPaginationNoFilter`)
  },
  getFlagList() {
    return OperationRepository.get(`${resource}/flag-list?noPagination`)
  },
  getBusinessList() {
    return OperationRepository.get(`${resource}/business-list`)
  },
  getMerchantBusinessNoPagination() {
    return OperationRepository.get('/merchant/business?noPagination')
  },
  getRoleDetails() {
    return OperationRepository.get(`${roleResource}`)
  },
  getPermissionTree() {
    return OperationRepository.get(`${permissionResource}`)
  },
  getReasonListForDropDown(key = '') {
    return OperationRepository.get(`${DropdownResource}/reason-list?status_key=${key}`)
  },
  getZoneListDropdown() {
    return OperationRepository.get(`${DropdownResource}/zone-list`)
  },
  getModules() {
    return OperationRepository.get(`${moduleResource}/all`)
  },
  fetchExcelTemplate(url) {
    return Repository.head(url)
  },
  getCityListDropdownByState(state) {
    return OperationRepository.get(`${resource}/city-list-by-state?state_id=${state}`)
  },
}
